<template>
  <!-- 添加拣货单-->
  <div class="AddPicking">
    <div class="AddPicking__top">
      <el-descriptions :column="3">
        <el-descriptions-item label="系统单号">
          <div>{{ pickingData.rsys }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="检索单号">
          <el-input v-model="pickingData.retrieval" placeholder="请输入内容(选填)" />
        </el-descriptions-item>
        <el-descriptions-item label="订单号">
          <el-input v-model="pickingData.order" placeholder="请输入内容(选填)" />
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="3">
        <el-descriptions-item label="出货门店">
          <el-select v-model="storeId" filterable placeholder="请选择" @change="checkStore">
            <el-option v-for="item in allStores" :key="item.sid" :label="item.cname" :value="item.sid" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="门店地址">
          <div class="wHP">{{ storeInfo.caddr }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <div class="flex alignItemsCenter">
        <el-descriptions :column="3">
          <el-descriptions-item label="订单渠道">
            <el-select v-model="pickingData.rchannel" filterable placeholder="请选择">
              <el-option v-for="item in channelOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="顾客地址">
            <el-input v-model="pickingData.customerAddr" placeholder="请输入内容" />
          </el-descriptions-item>
        </el-descriptions>
        <span class="icon iconfont grey">&#xe675;</span>
      </div>
      <el-divider></el-divider>
      <div class="flex alignItemsCenter">
        <el-descriptions :column="4">
          <el-descriptions-item label="销售组织">
            <div class="wHP">{{ pickingData.shopFinanceName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="销售门店">
            <div class="wHP">{{ pickingData.shopName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="库存组织">
            <div class="wHP">{{ pickingData.storeFinanceName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="出库门店">
            <div class="wHP">{{ storeInfo.cname }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-divider></el-divider>
      <div class="flex">
        <el-descriptions :column="1">
          <el-descriptions-item label="单据备注">
            <el-input v-model="pickingData.remarks" placeholder="请输入内容(选填)" />
          </el-descriptions-item>
        </el-descriptions>
        <div class="w200 flex" style="justify-content: flex-end">
          <el-button type="primary" size="mini" plain @click="deviceDialogVisible = true">门店智控</el-button>
        </div>
      </div>
    </div>
    <div class="h450 AddPicking__table">
      <el-table ref="multipleTable" :data="tableData" height="450">
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column align="center" label="SKU" width="90">
          <template #default="scope">
            <el-input v-model="scope.row.cremark" maxlength="5" placeholder="SKU" @input="checkSKU(scope.$index)" />
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl" :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="货品编码" align="center" width="130" prop="csku" />
        <el-table-column label="货品名称" align="center">
          <template #default="scope">
            <el-tooltip class="item" effect="dark" :disabled="!scope.row.c_name" :content="scope.row.c_name" placement="top">
              <el-select v-model="scope.row.sid" style="color: red" filterable placeholder="请选择" @change="checkGoodsName(scope.$index)">
                <el-option v-for="item in allInventorys" :key="item.sid" :label="item.sgoods + '可用数量：' + item.navailable" :value="item.sid" />
              </el-select>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="单位" align="center" width="50" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.nprice">￥ {{ scope.row.nprice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="库位" align="center" width="70" prop="c_num" >
          <template #default="scope">
            <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces;">
              <el-link type="primary">{{ scope.row.cwarehouse }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" width="130">
          <template #default="scope">
            <el-input-number v-model="scope.row.num" controls-position="right" :min="1" :max="999"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="red" @click="onDel(scope.$index)">删除</el-button>
            <el-button type="text" size="small" class="red" @click="handleShowSurplusDialog(scope.row)">校正库存</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
      <div>
        共计 <span class="blue">{{ tableData.length > 1 ? tableData.length - 1 : tableData.length }}种</span> 货品
      </div>
      <div>
        <el-button type="primary" @click="doSubmit">提交</el-button>
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </div>
    <el-dialog v-if="deviceDialogVisible" class="elDialog" :close-on-click-modal="false" title="查看门店智控" :visible.sync="deviceDialogVisible" width="400px" append-to-body>
      <deviceControl :store-info="storeInfo" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="库存校正" :visible.sync="surplusDialog" width="400px" append-to-body>
      <surplusSheet v-if="surplusDialog" :picking-detail="pickingDetail" @handleSubmit="handleSurplusSheetSubmit" @handleClose="handleSurplusSheetSubmit" />
    </el-dialog>
  </div>
</template>
<script>
import deviceControl from "./deviceControl.vue";
import channel from "@/utils/channel.js";
import surplusSheet from "./surplusSheet.vue";
export default {
  name: "AddPicking",
  components: { deviceControl, surplusSheet },
  data() {
    return {
      allInventorys: [],
      allStores: [],
      tableData: [],
      storeInfo: {},
      storeId: null,
      channelOptions: channel,
      pickingData: {},
      pickingDetail: {},
      deviceDialogVisible: false,
      surplusDialog: false,
    };
  },
  mounted() {
    this.tableData.push([]);
    this.selectByStoreName();
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    checkSKU(index) {
      if (sku.length === 5) {
        this.topsAjax.get(`${this.baseUrls.viewInventory}/getByStoreAndSku`, {rstore: this.storeInfo.sid, csku: this.tableData[index].cremark}).then((res) => {
          if (res) {
            this.$set(this.tableData, index, { ...res, num: 1});
            if (Object.keys(this.tableData[this.tableData.length - 1]).length !== 1) {
              this.tableData.push([]);
            }
          } else {
            this.$message.error("未获取到商品信息");
          }
        });
      }
    },
    handleShowSurplusDialog(row) {
      if (!row.sid) {
        this.$message.error("请选择需要校正的记录");
        return;
      }
      this.pickingDetail = row;
      this.pickingDetail.rinventory = row.sid;
      this.surplusDialog = true;
    },
    handleSurplusSheetSubmit(surplus) {
      this.surplusDialog = false;
    },
    selectByGoodsName() {
      this.topsAjax.get(`${this.baseUrls.viewInventory}/queryList`, { rstore: this.storeInfo.sid }).then((res) => {
        this.allInventorys = res;
      });
    },
    selectByStoreName() {
      this.topsAjax.get(`${this.baseUrls.viewInventory}/queryStore`).then((res) => {
        this.allStores = res;
      });
    },
    checkGoodsName(index) {
      for (let i = 0; i < this.allInventorys.length; i++) {
        if (this.tableData[index].sid === this.allInventorys[i].sid) {
          this.$set(this.tableData, index, { ...this.allInventorys[i], num: 1 });
          if (Object.keys(this.tableData[this.tableData.length - 1]).length !== 1) {
            this.tableData.push([]);
          }
          break;
        }
      }
    },
    checkStore() {
      for (let i = 0; i < this.allStores.length; i++) {
        if (this.allStores[i].sid === this.storeId) {
          this.storeInfo = { ...this.allStores[i] }
          this.selectByGoodsName();
          break;
        }
      }
    },
    onDel(index) {
      this.tableData.splice(index, 1);
    },
    doSubmit() {
      if (!this.storeInfo.sid) {
        this.$message.error("请选择门店");
        return;
      }
      if (!this.pickingData.rchannel) {
        this.$message.error("请选择订单渠道");
        return;
      }
      if (!this.pickingData.order) {
        this.$message.error("请填写订单号");
        return;
      }
      if (!this.pickingData.customerAddr) {
        this.$message.error("请填写顾客地址");
        return;
      }
      let goodsList = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].num) {
          if (this.tableData[i].sid) {
            goodsList.push(this.tableData[i]);
          }
        } else if (i != this.tableData.length - 1) {
          this.$message.error("请填写数量");
          return;
        }
      }
      if (goodsList.length === 0) {
        this.$message.error("请选择商品!");
        return;
      }
      let parameter = {
        picking: {
          sid: this.pickingId,
          sretrieval: this.pickingData.retrieval,
          rorder: this.pickingData.order,
          rstore: this.storeInfo.sid,
          sstore: this.storeInfo.cname,
          sstoreAddr: this.storeInfo.caddr,
          ccustomerAddr: this.pickingData.customerAddr,
          cremark: this.pickingData.remarks,
          rchannel: this.pickingData.rchannel
        },
        goodsList: goodsList,
      };

      this.topsAjax.get(`${this.baseUrls.ordPicking}/customerAddrRepeat`, { customerAddr: this.pickingData.customerAddr }).then((response) => {
          if (response) {
            this.$confirm("有重复顾客地址记录，是否继续录入？")
              .then((_) => {
                this.topsAjax.post(`${this.baseUrls.ordPicking}/add`, parameter).then((res) => {
                  this.$message({
                    showClose: true,
                    message: "新增成功",
                    type: "success",
                  });

                  this.handleClose();
                });
              });
          } else {
            this.topsAjax.post(`${this.baseUrls.ordPicking}/add`, parameter).then((res) => {
              this.$message({
                showClose: true,
                message: "新增成功",
                type: "success",
              });
              this.handleClose();
            });
          }
        });
    },
  },
};
</script>
<style lang="scss">
.AddPicking {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__top {
    .el-divider--horizontal {
      margin: 7px 0;
    }

    .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
      padding-bottom: 5px;
    }

    .el-input--medium .el-input__inner {
      height: 20px;
      line-height: 20px;
    }

    .el-input__inner {
      border: 0px;
    }

    //隐藏图标
    .el-input__icon {
      display: none;
    }
  }

  &__table {
    .el-input-number--medium {
      width: 100px;
    }

    .el-tabs__item.is-active {
      text-decoration: underline;
    }

    .el-popper[x-placement^="bottom"] {
      margin-left: -40px;
    }
  }
}
</style>
